import { GetServerSideProps } from 'next';
import { REDIRECT_HOME } from '@/lib/common';
import { SortValue } from '@/lib/collection-search-helpers';
import { getBrandCollectionProps } from '@/components/collections-v2/brand/helpers';
import {
  CollectionProps,
  CollectionServerSideProps,
} from '@/components/collections-v2/common/types';
import CollectionLayout from '@/components/collections-v2/common/Collections/CollectionLayout';
import BrandCollectionPage from '@/components/collections-v2/common/Collections/CollectionPage';

type Path = { pk: string };

export const getServerSideProps: GetServerSideProps<any, Path> = async ({
  query,
}) => {
  const handle = query.handle as string;
  const sort = query.sort as SortValue | undefined;

  if (!handle) return REDIRECT_HOME;

  const brandCollectionResults = (await getBrandCollectionProps(query, {
    variantFilters: { brand: [handle] },
    sort: sort ?? 'best-selling',
  })) as CollectionServerSideProps;

  const props: CollectionProps = JSON.parse(
    JSON.stringify({
      ...brandCollectionResults,
      pageTitle: `${handle} Products`,
    }),
  );

  return { props };
};

const Brand = (props: CollectionProps) => (
  <CollectionLayout {...props} key={props.pageTitle}>
    <BrandCollectionPage {...props} />
  </CollectionLayout>
);

export default Brand;
